import styled from 'styled-components'
import { Color, MediaBreakpoint } from 'root-constants'

type TTimerContainerProps = {
  isButtonVisible?: boolean
}

type TTimerTextProps = TTimerContainerProps
type TButtonContainerProps = TTimerContainerProps

export const StyledSubheaderWithTimer = {
  TimerContainer: styled.div<TTimerContainerProps>`
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    display: flex;
    justify-content: ${({ isButtonVisible }) =>
      isButtonVisible ? 'space-evenly' : 'center'};
    align-items: center;
    max-width: ${MediaBreakpoint.TABLET}px;
    min-height: 72px;
    margin: 0 auto 32px;
    background: ${({ isButtonVisible }) =>
      isButtonVisible
        ? 'linear-gradient(91.87deg, #a2dbf5 0%, #c396f7 100%);'
        : Color.GRADIENT};
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    z-index: 102;

    strong {
      padding: 0 10px 0;
      font-weight: 600;
      font-size: 28px;
      line-height: 22px;
      ${({ isButtonVisible }) =>
        isButtonVisible &&
        `
        font-weight: 700;
        font-size: 32px;
        line-height: 22px;
        color: ${Color.DARK}
        letter-spacing: 2px;
        `};
    }

    @media (min-width: ${MediaBreakpoint.TABLET}px) {
      max-width: 360px;
    }
  `,
  TimerText: styled.span<TTimerTextProps>`
    display: ${({ isButtonVisible }) =>
      isButtonVisible ? 'none' : 'inline-block'};
  `,
  ButtonContainer: styled.div<TButtonContainerProps>`
    display: ${({ isButtonVisible }) => (isButtonVisible ? 'initial' : 'none')};
  `,
  TimerButton: styled.button`
    height: 56px;
    min-width: 160px;
    margin: 5px;
    padding: 14px 20px;
    border: none;
    border-radius: 30px;
    background: ${Color.GRADIENT};
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: ${Color.WHITE};
    outline: none;
    cursor: pointer;
  `,

  Wrapper: styled.div<TButtonContainerProps>`
    ${({ isButtonVisible }) =>
      isButtonVisible &&
      `
    display: flex;
    flex-direction: column;
    color: ${Color.DARK};
    `}
  `,
}
